var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":_vm.autoplay,"indicator-color":"white"}},_vm._l((_vm.swiperData),function(item,index){return _c('div',{key:index,staticClass:"oSwiper"},[_c('van-swipe-item',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.url,"alt":""}})])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }